import ShortcutController from './Controller/ShortcutController';

$(document).ready(function () {
    new ShortcutController();
});